import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import advancedMapLayersSrc from './images/advanced-map-layers-thumb.avif';

const advancedMapLayers = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Advanced Map Layers' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Get detailed views of the land and terrain before you go' }),
  thumbnailImage: advancedMapLayersSrc.src
});

export default advancedMapLayers;
